import { CALL_API } from "../../../middlewares/api";

export const GET_USER_CLAIMS_REQUEST = "GET_USER_CLAIMS_REQUEST";
export const GET_USER_CLAIMS_SUCCESS = "GET_USER_CLAIMS_SUCCESS";
export const GET_USER_CLAIMS_ERROR = "GET_USER_CLAIMS_ERROR";

export const fetch_user_claims = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/users/staff/user-claims",
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_USER_CLAIMS_REQUEST,
        GET_USER_CLAIMS_SUCCESS,
        GET_USER_CLAIMS_ERROR,
      ],
    },
  };
};
